import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { scrollToTop } from '../../utils';
export const FORM_ID = 'generic-input';
const StepperFormFooter = ({ currentStepIndex, disableBack, disableNext, setDisableNext, steps, baseURL }) => {
    const { t } = useTranslation('shared');
    const navigate = useNavigate();
    const goBack = useCallback(() => {
        scrollToTop();
        if (currentStepIndex <= 0) {
            navigate(baseURL);
        }
        else {
            navigate(`${baseURL}/${steps[currentStepIndex - 1]}`);
        }
        if (setDisableNext) {
            setDisableNext(false);
        }
    }, [currentStepIndex, navigate, setDisableNext, steps, baseURL]);
    return (_jsxs("footer", { className: "form-footer", children: [_jsxs("button", { disabled: disableBack, type: "button", onClick: goBack, className: "btn btn-grey", children: [_jsx("i", { className: "fa-light fa-arrow-left" }), _jsx("span", { children: t('common.back') })] }), _jsx("div", { className: "step-count", children: _jsxs("span", { children: [currentStepIndex + 1, "\u00A0/\u00A0", steps.length] }) }), _jsxs("button", { type: "submit", className: "btn btn-blue btn-simple", disabled: disableNext, form: FORM_ID, children: [_jsx("span", { children: t('common.next') }), _jsx("i", { className: "fa-regular fa-arrow-right" })] })] }));
};
export default StepperFormFooter;
